// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1VyRK","approved":"Status_approved__1KBtk","rejected":"Status_rejected__2vnmM","expired":"Status_expired__1E1Kv","label":"Status_label__2bN4c"};